<template>
    <div>Base App</div>
</template>

<script>
import { mapGetters } from 'vuex'
const pjson = require('@/../package.json')

export default {
    name: "BaseApp",
    computed: {
        ...mapGetters([
            'getUserTokenState',
            'getUserDetails',
            'getUserUsername',
            'getCompany'
        ])
    },
    data: function (){
        let   app_version =  pjson.version
        const patch   = pjson.version.substr (pjson.version.lastIndexOf("."))
        if (patch == ".0") {
            app_version = pjson.version.substr (0, pjson.version.lastIndexOf("."))
        }
        return {
            isActive:false,
            version: app_version,
            refreshing: false,
            registration: null,
            updateExists: false,
        }
    },
    created () {
        const token = localStorage.getItem ("token")
        if (this.token) {
            this.setToken (token)
        }
        // Listen for swUpdated event and display refresh snackbar as required.
        document.addEventListener (
            "swUpdated", this.showRefreshUI, { once: true })
        if (navigator.serviceWorker) {
            // Refresh all open app tabs when a new service worker is installed.
            navigator.serviceWorker.addEventListener ("controllerchange", () => {
                if (this.refreshing) return
                this.refreshing = true
                window.location.reload()
            });
        } else {
            console.log ("navigator.serviceWorker is undefined !")
        }
    },
    methods: {
        showRefreshUI (e) {
            // Display a button inviting the user to refresh/reload the app due
            // to an app update being available.
            // The new service worker is installed, but not yet active.
            // Store the ServiceWorkerRegistration instance for later use.
            this.registration = e.detail
            this.updateExists = true
            this.$buefy.snackbar.open ({
                message:     this.$t ("new-version-avaiable"),
                type:       'is-warning',
                position:   'is-top',
                actionText:  this.$t ("update-sw"),
                indefinite:  true,
                onAction: () => {
                    this.refreshApp ()
                }
            })
        },
        refreshApp () {
            // Handle a user tap on the update app button.
            this.updateExists = false;
            // Protect against missing registration.waiting.
            if (!this.registration || !this.registration.waiting) { return }
            this.registration.waiting.postMessage ("skipWaiting")
        },
        setToken (state,payload) {
            this.$store.dispatch ('setToken',payload)
        },
        toogleMobile (){
            this.isActive= !this.isActive
        },
        switchLanguage( language) {
            this.$i18n.locale = language
            localStorage.setItem ("language", language)
            this.$validator.localize (language)
        },
    }
}
</script>

<style>
    .toast {
        padding: 0.5em 1.5em !important;
    }
</style>